<section class="page-stack">
  <div class="crud-panel">
    <div class="crud-header">
      <div><span class="eyebrow">QR Interoperable</span><h2>BIND</h2></div>
      <button class="primary-button add-button" type="button" (click)="openAssign()" [disabled]="saving">+ Asignar QR al terminal</button>
    </div>

    <form class="crud-tools qri-tools" (ngSubmit)="applyFilters()">
      <input type="text" name="idCaja" aria-label="Caja ID" placeholder="Caja ID" [(ngModel)]="filters.idCaja">
      <input type="number" name="idQr" min="1" step="1" aria-label="QR ID" placeholder="QR ID" [(ngModel)]="filters.idQr">
      <input type="text" name="terminalId" aria-label="Terminal ID" placeholder="Terminal ID" [(ngModel)]="filters.terminalId">
      <button class="ghost-button" type="button" (click)="clearFilters()" [disabled]="tableLoading">Limpiar</button>
      <button class="primary-button" type="submit" [disabled]="tableLoading">Filtrar</button>
    </form>

    <div class="state success-state" role="status" *ngIf="message">{{ message }}</div>
    <div class="state error" role="alert" *ngIf="error">{{ error }}</div>

    <div class="table-wrap" [attr.aria-busy]="tableLoading">
      <table class="crud-table">
        <thead><tr><th>ID</th><th>Terminal ID</th><th>Caja ID</th><th>QR ID</th><th>Provider</th><th>QR String</th><th>Acciones</th></tr></thead>
        <tbody>
          <tr *ngFor="let row of rows">
            <td>{{ row.id }}</td><td>{{ row.terminalId }}</td><td>{{ row.idCaja }}</td><td>{{ row.idQr }}</td>
            <td><span class="badge">{{ row.provider }}</span></td>
            <td class="qr-cell"><details><summary>Ver QR String</summary><code>{{ row.qrString }}</code></details></td>
            <td><div class="row-actions"><button class="action-button delete" type="button" title="Eliminar asignación" [attr.aria-label]="'Eliminar asignación de ' + row.terminalId" (click)="openDelete(row)" [disabled]="saving">×</button></div></td>
          </tr>
          <tr *ngIf="!rows.length && !tableLoading"><td colspan="7">Sin resultados</td></tr>
          <tr *ngIf="tableLoading"><td colspan="7">Cargando asignaciones...</td></tr>
        </tbody>
      </table>
    </div>

    <div class="pagination">
      <div class="pagination-status"><span class="loading-spinner" *ngIf="tableLoading"></span>{{ total }} asignaciones</div>
      <label class="inline-control">Registros
        <select [(ngModel)]="size" (ngModelChange)="changeSize()" [disabled]="tableLoading"><option *ngFor="let option of pageSizes" [ngValue]="option">{{ option }}</option></select>
      </label>
      <div class="pagination-actions">
        <button class="ghost-button" type="button" (click)="changePage(page - 1)" [disabled]="tableLoading || page === 0">Anterior</button>
        <app-page-navigation [page]="page" [totalPages]="totalPages" [disabled]="tableLoading" (pageChange)="changePage($event)"></app-page-navigation>
        <button class="ghost-button" type="button" (click)="changePage(page + 1)" [disabled]="tableLoading || page + 1 >= totalPages">Siguiente</button>
      </div>
    </div>
  </div>

  <div class="modal-backdrop" *ngIf="modalOpen">
    <form class="modal credential-modal" role="dialog" aria-modal="true" aria-labelledby="assign-qri-title" (ngSubmit)="assign()">
      <header><div><span class="eyebrow">QR Interoperable · BIND</span><h3 id="assign-qri-title">Asignar QR al terminal</h3></div>
        <button class="icon-button" type="button" aria-label="Cerrar" (click)="closeModal()" [disabled]="saving || terminalsLoading">×</button>
      </header>
      <div class="state error" role="alert" *ngIf="dialogError">{{ dialogError }}</div>
      <div class="credential-form">
        <label>Terminal virtual
          <select name="virtualTerminal" [(ngModel)]="selectedTerminalId" [disabled]="saving || terminalsLoading" required>
            <option [ngValue]="null">{{ terminalsLoading ? 'Cargando terminales...' : 'Seleccionar terminal virtual' }}</option>
            <option *ngFor="let terminal of available" [ngValue]="terminal.id">{{ terminal.terminalId }} · Cliente {{ terminal.clientId ?? 'sin asignar' }}</option>
          </select>
        </label>
      </div>
      <p *ngIf="!terminalsLoading && !available.length && !dialogError">No hay terminales virtuales sin QRI.</p>
      <div class="header-actions">
        <button class="ghost-button" type="button" (click)="closeModal()" [disabled]="saving || terminalsLoading">Cancelar</button>
        <button class="primary-button" type="submit" [disabled]="saving || terminalsLoading || selectedTerminalId === null">{{ saving ? 'Asignando...' : 'Asignar QR' }}</button>
      </div>
    </form>
  </div>

  <div class="modal-backdrop" *ngIf="deleting">
    <div class="modal credential-modal" role="dialog" aria-modal="true" aria-labelledby="delete-qri-title">
      <header><h3 id="delete-qri-title">Eliminar asignación</h3><button class="icon-button" type="button" aria-label="Cerrar" (click)="closeModal()" [disabled]="saving">×</button></header>
      <p>Se eliminará la asignación de la caja <strong>{{ deleting.idCaja }}</strong> y el QR {{ deleting.idQr }} a la terminal <strong>{{ deleting.terminalId }}</strong>.</p>
      <p>La terminal quedará disponible para crear otro QR. Esta acción elimina el registro local; la caja y el QR continúan en BIND.</p>
      <div class="state error" role="alert" *ngIf="dialogError">{{ dialogError }}</div>
      <div class="header-actions">
        <button class="ghost-button" type="button" (click)="closeModal()" [disabled]="saving">Cancelar</button>
        <button class="primary-button" type="button" (click)="confirmDelete()" [disabled]="saving">{{ saving ? 'Eliminando...' : 'Eliminar asignación' }}</button>
      </div>
    </div>
  </div>
</section>
